export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const SEEDFLEX_BASE_URL = `${process.env.REACT_APP_BASE_URL_SEEDFLEX}`;
export const SEEDFLEX_OAUTH_CLIENT_ID = `${process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}`;
export const DI_CORE_SEEDFLEX_AUTH_CLIENT_ID = `${process.env.REACT_APP_DI_CORE_SEEDFLEX_AUTH_CLIENT_ID}`;
export const DI_CORE_SEEDFLEX_AUTH_CLIENT_SECRET = `${process.env.REACT_APP_DI_CORE_SEEDFLEX_AUTH_CLIENT_SECRET}`;
export const LO_CORE_SEEDFLEX_AUTH_CLIENT_ID = `${process.env.REACT_APP_LO_CORE_SEEDFLEX_AUTH_CLIENT_ID}`;
export const LO_CORE_SEEDFLEX_AUTH_CLIENT_SECRET = `${process.env.REACT_APP_LO_CORE_SEEDFLEX_AUTH_CLIENT_SECRET}`;
export const SF_CORE_SEEDFLEX_AUTH_CLIENT_ID = `${process.env.REACT_APP_SF_CORE_SEEDFLEX_AUTH_CLIENT_ID}`;
export const SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET = `${process.env.REACT_APP_SF_CORE_SEEDFLEX_AUTH_CLIENT_SECRET}`;
export const PO_CORE_SEEDFLEX_AUTH_CLIENT_ID = `${process.env.REACT_APP_PO_CORE_SEEDFLEX_AUTH_CLIENT_ID}`;
export const PO_CORE_SEEDFLEX_AUTH_CLIENT_SECRET = `${process.env.REACT_APP_PO_CORE_SEEDFLEX_AUTH_CLIENT_SECRET}`;
export const SF_CORE_ROUTE = `${process.env.REACT_APP_SF_CORE_ROUTE}`;
export const LO_CORE_ROUTE = `${process.env.REACT_APP_LO_CORE_ROUTE}`;
export const DI_ROUTE = `${process.env.REACT_APP_DI_ROUTE}`;
export const RESTRICTED = `${process.env.REACT_APP_RESTRICTED}` === 'true';
export const AGENT_URL = `${process.env.REACT_APP_AGENT_URL}`;
export const AWS_ID = `${process.env.REACT_APP_AWS_ACCESS_KEY_ID}`;
export const AWS_SECRET = `${process.env.REACT_APP_AWS_SECRET_ACCESS_KEY}`;
export const BUCKET_NAME = `${process.env.REACT_APP_AWS_BUCKET_NAME}`;
export const BUCKET_REGION = `${process.env.REACT_APP_AWS_REGION}`;
export const CTOS_CHECK = `${process.env.REACT_APP_CTOS_CHECK}`;
export const DTM_PARTNERS = process.env.REACT_APP_DTM_PARTNER_IDS
  ? process.env.REACT_APP_DTM_PARTNER_IDS.split(',').map((id) => id.trim())
  : [];
export const SEEDFLEX_GOOGLE_SITEKEY = `${process.env.REACT_APP_GOOGLE_SITEKEY}`;
export const BASE_MW_URL = `${process.env.REACT_APP_MW_URL}`;
export const CAI_URL = `${process.env.REACT_APP_CAI_URL}`;
export const PAYE_PARTNERS = process.env.REACT_APP_PAYE_PARTNER_IDS
  ? process.env.REACT_APP_PAYE_PARTNER_IDS.split(',').map((id) => id.trim())
  : [];
export const OTP_COUNTDOWN = `${process.env.REACT_APP_RESEND_COUNTDOWN}`;
